import { render, staticRenderFns } from "./crateDetailPanel.vue?vue&type=template&id=7fb302b0&"
import script from "./crateDetailPanel.vue?vue&type=script&lang=js&"
export * from "./crateDetailPanel.vue?vue&type=script&lang=js&"
import style0 from "./crateDetailPanel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports